module.exports = __webpack_public_path__ + "static/img/umbrella-campaigns-banner.0efd015f.png";